import { ExclamationCircleOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, message, Modal, Upload } from 'antd';
import { RcFile } from 'antd/es/upload';
import { Loader } from 'components';
import { useUploadBulkExcelCoupon } from 'features/shop-item/use-cases/coupon-bulk-upload';
// import { useUploadBulkExcel } from 'features/transaction_list/use-cases/upload-bulk-excel';
import { useState } from 'react';
import * as XLSX from 'xlsx';


export const EventCouponBulkUpload = ({ id }: { id: any }) => {


    const [fileList, setFileList] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    const { mutate } = useUploadBulkExcelCoupon();


   const handleUpload = async (file: RcFile) => {
        setLoading(true);
        const isExcel =
            file.type === 'application/vnd.ms-excel' ||
            file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

        if (!isExcel) {
            message.error('You can only upload Excel files!');
            setLoading(false);
            
return false;
        }
         const reader = new FileReader();
        reader.onload = (e: ProgressEvent<FileReader>) => {
            const data = e.target?.result;
            const workbook = XLSX.read(data, { type: 'binary' });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            
            // Converts sheet to objects: { "Category": "test", "Coupon Code": "123" }
            const jsonData: any[] = XLSX.utils.sheet_to_json(sheet);

            if (jsonData.length === 0) {
                message.error('The Excel file does not contain any data rows.');
                setLoading(false);
                
return;
            }
            const errors: string[] = [];

            jsonData.forEach((row, index) => {
                const rowNum = index + 2; // Row 1 is header, data starts at 2

                // 1. Required Field Validation
                if (!row["Category"]) errors.push(`Row ${rowNum}: Category is missing.`);
                if (!row["Coupon Title"]) errors.push(`Row ${rowNum}: Coupon Title is missing.`);
                if (!row["Coupon Code"]) errors.push(`Row ${rowNum}: Coupon Code is missing.`);
                
                // 2. Number Validation
                if (row["Limit Usage"] === undefined || isNaN(Number(row["Limit Usage"]))) {
                    errors.push(`Row ${rowNum}: Limit Usage must be a number.`);
                }
                if (row["Value"] === undefined || isNaN(Number(row["Value"]))) {
                    errors.push(`Row ${rowNum}: Value must be a number.`);
                }

                // 3. Choice Validation
                if (!["Flat", "Percent"].includes(row["Value Type"])) {
                    errors.push(`Row ${rowNum}: Value Type must be 'Flat' or 'Percent'.`);
                }
                if (!["Yes", "No"].includes(row["Multiple Use"])) {
                    errors.push(`Row ${rowNum}: Multiple Use must be 'Yes' or 'No'.`);
                }

                // 4. Custom Date Parsing for DD-MM-YYYY
                const parseDate = (dateVal: any) => {
                    if (!dateVal) return null;
                    if (typeof dateVal === 'number') {
                        // Handle Excel numeric date format
                        return new Date(Math.round((dateVal - 25569) * 86400 * 1000));
                    }
                    const parts = String(dateVal).split(/[-/]/);
                    if (parts.length === 3) {
                        // Constructor: (YYYY, MonthIndex, DD)
                        return new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
                    }
                    
return new Date(dateVal);
                };
                const startDate = parseDate(row["Start Date"]);
                const endDate = parseDate(row["End Date"]);

                if (!startDate || isNaN(startDate.getTime())) errors.push(`Row ${rowNum}: Invalid Start Date.`);
                if (!endDate || isNaN(endDate.getTime())) errors.push(`Row ${rowNum}: Invalid End Date.`);
                
                if (startDate && endDate && startDate >= endDate) {
                    errors.push(`Row ${rowNum}: End Date must be after Start Date.`);
                }
            });

            setLoading(false);
            if (errors.length === 0) {
                handlePostExcel(file);
            } else {
                showValidationErrors(errors);
            }
        };

        reader.readAsBinaryString(file);
        
return false; // Prevent automatic upload by Ant Design
    };
    const showValidationErrors = (errors: string[]) => {
        Modal.error({
            title: 'Validation Errors',
            content: (
                <ul>
                    {errors.map((error, index) => (
                        <li key={index}><b>{error}</b></li>
                    ))}
                </ul>
            ),
            icon: <ExclamationCircleOutlined />,
            okText: 'OK',
        });
    };


   
    if (loading) return <Loader />;

    const handleChange = (info: { file: any; fileList: any; }) => {
        const newFileList = info.fileList.slice(-1); // Keep only the latest file
        setFileList(newFileList);

        if (info.file.status === 'done') {
            message.success(`${info.file.name} file uploaded successfully`);
            setFileList([]); // Clear the file list
        } else if (info.file.status === 'error') {
            message.error(`${info.file.name} file upload failed.`);
        }
    };

    const handlePostExcel = (file: any) => {
        const formData = new FormData();
        formData.append(`EventId`, id);
        formData.append(`File`, file);
        formData.append(`Flag`, "manual");
        mutate(formData, {
            onSuccess: () => {
                handleChange({ file, fileList: [] });
            }
        });

    }





    // if (isLoading) return <Spin />;

    return (
        <div >
            <Upload
                beforeUpload={handleUpload}
                accept=".xls, .xlsx"
                // disabled={!eventNameSelected}
                multiple={false}
                showUploadList={true}
                fileList={fileList}
                onChange={handleChange}
            >
                <Button icon={<UploadOutlined />} style={{ marginRight: '18px' }} className='btn_common'>
                    Bulk Upload
                </Button>
            </Upload>


        </div>
    );
};



